var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"common-level-rail"},[_c('el-radio',{attrs:{"label":"news"},model:{value:(_vm.radio),callback:function ($$v) {_vm.radio=$$v},expression:"radio"}},[_vm._v("图文素材("+_vm._s(_vm.newsCount)+")")]),_vm._v(" "),_c('el-button',{staticClass:"MpInfoBtn",attrs:{"type":"primary"},on:{"click":_vm.postMpInfo}},[_vm._v("下一步")])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-ef4c0fbe","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/plus/article/mp/mp.vue
// module id = null
// module chunks = 